(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-category-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let windowHash = window.location.hash;
    if (windowHash !== '') {
      let targetEl = document.querySelector(windowHash);
      if (targetEl && targetEl.classList.contains('gift_category_panel')) {
        let parentSectionId = targetEl.getAttribute('parent-section-id');
        if (parentSectionId) {
          document
            .querySelectorAll(parentSectionId + ' .gift_category_panel')
            .forEach((el) => el.classList.remove('active'));

          let targetPanel = document.querySelector(parentSectionId + ' ' + windowHash + '.gift_category_panel');
          if (targetPanel) targetPanel.classList.add('active');

          document
            .querySelectorAll(parentSectionId + ' .gift_category_indicator_link')
            .forEach((el) => el.classList.remove('active'));

          let targetLink = document.querySelector(
            parentSectionId + ' .gift_category_indicator_link[href="' + windowHash + '"]'
          );
          if (targetLink) targetLink.classList.add('active');
        }
      }
    }

    document.querySelectorAll('.gift_category_indicator_link').forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault();

        let thisHref = this.getAttribute('href');
        let parentSectionId = this.getAttribute('parent-section-id');
        if (parentSectionId) {
          document
            .querySelectorAll(parentSectionId + ' .gift_category_panel')
            .forEach((el) => el.classList.remove('active'));

          let targetPanel = document.querySelector(parentSectionId + ' ' + thisHref + '.gift_category_panel');
          if (targetPanel) targetPanel.classList.add('active');

          document
            .querySelectorAll(parentSectionId + ' .gift_category_indicator_link')
            .forEach((el) => el.classList.remove('active'));

          let targetLink = document.querySelector(
            parentSectionId + ' .gift_category_indicator_link[href="' + thisHref + '"]'
          );
          if (targetLink) targetLink.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-tabing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let windowHash = window.location.hash;
    if (windowHash !== '') {
      let targetEl = document.querySelector(windowHash);
      if (targetEl && targetEl.classList.contains('gift_tabing_panel')) {
        let parentSectionId = targetEl.getAttribute('parent-section-id');
        if (parentSectionId) {
          document
            .querySelectorAll(parentSectionId + ' .gift_tabing_panel')
            .forEach((el) => el.classList.remove('active'));

          let targetPanel = document.querySelector(parentSectionId + ' ' + windowHash + '.gift_tabing_panel');
          if (targetPanel) targetPanel.classList.add('active');

          document
            .querySelectorAll(parentSectionId + ' .gift_tabing_indicator_link')
            .forEach((el) => el.classList.remove('active'));

          let targetLink = document.querySelector(
            parentSectionId + ' .gift_tabing_indicator_link[href="' + windowHash + '"]'
          );
          if (targetLink) targetLink.classList.add('active');
        }
      }
    }

    document.querySelectorAll('.gift_tabing_indicator_link').forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault();

        let thisHref = this.getAttribute('href');
        let parentSectionId = this.getAttribute('parent-section-id');

        if (parentSectionId) {
          document
            .querySelectorAll(parentSectionId + ' .gift_tabing_panel')
            .forEach((el) => el.classList.remove('active'));

          let targetPanel = document.querySelector(parentSectionId + ' ' + thisHref + '.gift_tabing_panel');
          if (targetPanel) targetPanel.classList.add('active');

          document
            .querySelectorAll(parentSectionId + ' .gift_tabing_indicator_link')
            .forEach((el) => el.classList.remove('active'));

          let targetLink = document.querySelector(
            parentSectionId + ' .gift_tabing_indicator_link[href="' + thisHref + '"]'
          );
          if (targetLink) targetLink.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const signupPopup = document.getElementById('SignupPopup');
    const closeBtn = document.getElementById('signupPopupClose');
    const backdrop = document.getElementById('signupPopupBackdrop');

    const STORAGE_KEY = 'signupPopupClosedUntil';

    // Check if popup should be shown
    const closedUntil = localStorage.getItem(STORAGE_KEY);
    const now = new Date().getTime();

    // Only show popup if user hasn't closed it within last 24 hours
    if (!closedUntil || now > parseInt(closedUntil)) {
      setTimeout(function () {
        signupPopup.classList.add('active');
      }, 2000);
    }

    // Function to close popup and store close timestamp
    function closePopup() {
      signupPopup.classList.remove('active');
      const oneDayLater = now + 24 * 60 * 60 * 1000; // 1 day in ms
      localStorage.setItem(STORAGE_KEY, oneDayLater.toString());
    }

    // Close on click (button or backdrop)
    [closeBtn, backdrop].forEach((element) => {
      if (element) {
        element.addEventListener('click', closePopup);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
